<template>
  <div class="container">
    <div class="rounds">
      <a href="?round=round1" class="bracket-link"><button>Ronda 1</button></a>
      <a href="?round=round2" class="bracket-link"><button>Ronda 2</button></a>
      <a href="?round=round3" class="bracket-link"><button>Ronda 3</button></a>
      <!--<a href="?round=round4" class="bracket-link"><button>Ronda 4</button></a>
      <br>
      <a href="?round=octavos" class="bracket-link"><button>Ronda de 16</button></a>-->
      <br>
      <a href="?round=cuartos" class="bracket-link"><button>Quatros de final</button></a>
      <a href="?round=semifinal" class="bracket-link"><button>Semi-final</button></a>
      <br>
      <a href="?round=final" class="bracket-link"><button>Final</button></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Rounds"
}
</script>


<style lang="scss" scoped>
.container{
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 50px;

  .rounds{
    text-align: center;
  }

  .bracket-link {
    margin: 1rem;
  }



  button{
    width: 308px;
    height: 44px;
    background: #0092bc;
    border: none;
    transition: all .2s;
    cursor: pointer;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #012A2D;
    margin-bottom: 40px;
    @media only screen and (max-width:740px){
      width: 270px;
    }
    &:active{
      transform: scale(0.95);
    }
    &:hover{
      box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.05);
    }
  }
}

</style>